import { render, staticRenderFns } from "./UserManagementDetail.vue?vue&type=template&id=3cb7a98a&scoped=true&"
import script from "./UserManagementDetail.vue?vue&type=script&lang=js&"
export * from "./UserManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementDetail.vue?vue&type=style&index=0&id=3cb7a98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7a98a",
  null
  
)

export default component.exports